export const migrationEndpoints = (builder) => ({
    // Migration
    getUserMigrations: builder.query({
        query: (status) => ({
            url: `/users/migration/migrated${(status === 0 || status) ? `?status=${status}` : ""}`,
            method: 'get'
        }),
        providesTags: ['Migrations'],
    }),
    getUserMigrationLogs: builder.query({
        query: ({userId, sessionId}) => ({url: `/users/migration/${userId}/logs?_=${sessionId}`, method: 'get'}),
        providesTags: ['Migrations'],
    }),
    migrateUser: builder.mutation({
        query: ({userId, ...data}) => ({url: `/users/migration/${userId}/migrate`, method: 'put', body: data}),
        invalidatesTags: ['Migrations'],
    }),
    resetUserMigration: builder.mutation({
        query: ({userId, email}) => ({url: `/users/migration/${userId}/reset`, method: 'put', body: {email}}),
        invalidatesTags: ['Migrations'],
    }),
})